import React from 'react';
import styled from 'styled-components';
import LogoMain from '../../assets/images/logo-white-text.png';
import { publicPortals, routePaths } from '../../utils/consts';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #2a2c42;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  flex-direction: column;
  text-align: center;
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 45px;
  margin-bottom: 4rem;

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 25px;
  }
`;

const Pipe = styled.div`
  width: 1px;
  height: 80px;
  background-color: #fff;
  @media (max-width: 576px) {
    display: none;
  }
`;

const AnchorTag = styled.a`
  padding: 8px 14px;
  font-size: 2rem;
  font-weight: 600;
  color: #fff;
  background: #4e73c3;
  border-radius: 4px;
  text-decoration: none;
`;

const NotFound = () => {
  const user = localStorage.getItem('user');
  const isPublic = user && publicPortals.find((pp: string) => pp === user);
  const hrefPath = isPublic ? `/${user}` : routePaths.app;
  const anchorText = !user ? 'Back to Login' : isPublic ? 'Back to Map' : 'Back to Location';

  return (
    <Container>
      <img src={LogoMain} alt="EarthSense logo" style={{ position: 'absolute', top: '29%', maxWidth: 350 }} />
      <TextContainer>
        <div style={{ fontSize: '50px' }}>404</div>
        <Pipe />
        <div style={{ fontSize: '24px' }}>This page could not be found.</div>
      </TextContainer>
      <AnchorTag href={hrefPath} >{anchorText}</AnchorTag>
    </Container>
  );
};

export default NotFound;
